<template>
    <div class="CardItem">
        <div class="container" >
            <div class="income" v-if="setTab == 1">
                <section v-for="(item, index) in incomeData" :key="index">
                    <div class="item">
                        <div class="desc">
                            <div class="consumeType">
                                <img src="@/assets/images/mealCard/Presented.png" alt="">
                            </div>
                        <div class="type">
                            <p class="title">{{item.title}}</p>
                            <p class="time">{{item.created_at}}</p>
                        </div>
                        </div>
                        <div class="price">
                            <span>+{{item.money}}</span>
                        </div>
                    </div>
                </section>
                <div class="empty" v-if="incomeData==''">
                    <Divider Msg="暂无更多数据"/>
                </div>
            </div>
            <div class="spending" v-if="setTab == 2">
                <section v-for="(item, index) in outputData" :key="index">
                    <div class="item">
                        <div class="desc">
                            <div class="consumeType">
                                <img src="@/assets/images/mealCard/wechat.png" alt="">
                            </div>
                        <div class="type">
                                <p class="title">{{item.title}}</p>
                                <p class="time">{{item.created_at}}</p>
                        </div>
                        </div>
                        <div class="price lose">
                            <span>-{{item.money}}</span>
                        </div>
                    </div>
                </section>
                <div class="empty" v-if="outputData==''">
                    <Divider Msg="暂无更多数据"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Divider from "@/components/Divider";
import { cardLog } from "@/interface/member";
import $localStorage from "@/utils/localStorage";
export default {
    components: {
        Divider
    },
    props: {
        setTab: {
            type: Number,
            default: 1
        },
        card:{
            type: String,
            default: null
        }
    },
    data() {
        return {
            incomeData: [], // 收入
            outputData: [], // 支出
            InputPage: 1,
            OutputPage: 1
        };
    },
    created() {
        this.getInput();
        this.getOutput();
        window.addEventListener("scroll", this.scrollFn);
    },
    methods: {
        scrollFn(){
             //真实内容的高度
             var pageHeight = Math.max(document.body.scrollHeight,document.body.offsetHeight);
             //视窗的高度
             var viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0;
             //隐藏的高度
             var scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
             if(this.setTab==1){
                if(this.falgNoData1){ //数据全部加载完了
                    return;
                }else if(pageHeight - viewportHeight - scrollHeight < 10){    //如果满足触发条件，执行
                    this.getInput()
                }
             }
             if(this.setTab==2){
                 if(this.falgNoData2){ //数据全部加载完了
                    return;
                }else if(pageHeight - viewportHeight - scrollHeight < 10){    //如果满足触发条件，执行
                     this.getOutput()
                }
             }
        },
        // 收入
        getInput() {
            let UserInfo = $localStorage.get("xxUserInfo") || {};
            let data = {
                user_id: UserInfo.user_id,
                card_no: this.card,
                page: this.InputPage,
                type: 1
            };
            cardLog(data)
                .then(res => {
                    if (parseInt(res.errcode) == 0) {
                        this.incomeData = res.result;
                        res.result.forEach(element => {
                           this.incomeData.push(element);
                        });
                        if(res.result.length == 0){ //当前页码大于等于总页码
                            this.falgNoData1 = true;
                        }
                        this.InputPage++; 
                    }
                })
        },
        // 支出
        getOutput() {
            let UserInfo = $localStorage.get("xxUserInfo") || {};
            let data = {
                user_id: UserInfo.user_id,
                card_no: this.card,
                page: this.OutputPage,
                type: 2
            };
            cardLog(data)
                .then(res => {
                    if (parseInt(res.errcode) == 0) {
                        res.result.forEach(element => {
                           this.outputData.push(element);
                        });
                        if(res.result.length == 0){ //当前页码大于等于总页码
                            this.falgNoData1 = true;
                        }
                        this.OutputPage++; 
                    }
                })
        }
    }
};
</script>
<style lang="scss" scoped>
@import "~@/scss/libs.scss";
.CardItem {
    position: relative;
    margin-top: px2rem(20);
    background: white;
    .container{
        position: relative;
    }
    .empty {
        padding: px2rem(50);
        background: #f1f1f1;
    }
    section {
        position: relative;
        &::after {
            content: "";
            @include pos-a(auto, px2rem(20), 0, px2rem(20));
            border-bottom: px2rem(1.1) solid #e4e4e4;
        }
        &:last-child:after {
            content: "";
            border: none;
        }
    }
    .item {
        padding: px2rem(30);
        position: relative;
        background: white;
        @include dis-flex(space-between);
        .desc {
            flex: 1;
            @include text-ellipsis;
            @include dis-flex(flex-start);
            .consumeType {
                margin-right: px2rem(30);
                display: inline-block;
                img {
                    @include square(px2rem(88));
                }
            }
            .type {
                padding-top: px2rem(5);
                .title {
                    font-size: px2rem(28);
                    color: $grayCyan;
                }
                .time {
                    margin-top: px2rem(14);
                    color: $gray;
                    font-size: px2rem(22);
                }
            }
        }
        .price {
            text-align: right;
            padding-top: px2rem(10);
            flex: 0 0 px2rem(96);
            font-size: px2rem(28);
            color: #50c25e;
        }
        .lose {
            color: $shallowRed;
        }
    }
}
</style>